<template>
  <div style="height: 85vh; width: 84vw; background-color: white; " class="pt-4">
    <v-row class="pt-1; pb-1">
      <v-col class="pl-7">
        <div style="height: 82vh; width: 52vw">
          <l-map ref="refMap" class="small-map" :zoom="zoom" :center="center" @update:zoom="zoomUpdated"
            @update:center="centerUpdated" @update:bounds="boundsUpdated">
            <custom-tile-layer :url="tileProviders.url" :attribution="tileProviders.attribution" :maxZoom="22"
              :maxNativeZoom="18" />
            <l-feature-group ref="featureGroup" />
            <l-control :title="this.$t('_afficher_tous_les_points_de_mesure_')" class="seeButton">
              <v-icon v-if="show" :position="'topright'" style="width: 13px; height: 10px; color: black"
                @click="toggleText">
                mdi-eye-outline
              </v-icon>
              <v-icon v-else :position="'topright'" style="width: 13px; height: 10px; color: black" @click="toggleText">
                mdi-eye-off-outline
              </v-icon>
            </l-control>
            <l-polygon v-if="editing || isDrawing" :lat-lngs="polygonCoords" color="white" fillColor="none"
              :options="{ zIndex: 0 }" />
          </l-map>
        </div>
      </v-col>
      <Attribution v-if="modalState" :rectangleCoords="modalCoords" :pastMpp="modalMpp" @close="closeModal()"
        @save="saveMpp($event, blockIndex)" @newSave="saveNewBlocs($event, blockIndex)" />
      <v-col style="height: 82vh">
        <v-btn @click="this.onDetourage" style="float: right; right: 25px; font-size: medium;">
          {{ $t('_modifier_perimetre_site') }}
        </v-btn>
        <div class="p-4; pt-15">
          <table>
            <thead>
              <tr>
                <th>{{ $t('_pdm_') }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in sortedMpps">
                <tr :key="'row' + index">
                  <td :class="isAllocated(item.id) ? 'ligneAlloue' : 'lignePasAlloue'">
                    {{ item.mpp }}
                    <button v-if="isAllocated(item.id)" @click="toggleOeil(index)"
                      :class="exandedIndexOeil === index ? 'eye-select' : 'eye'">
                      👁
                    </button>
                  </td>
                  <td @click="toggleDetails(index)" class="fleche">
                    <i :class="exandedIndexFleche === index ? 'arrow-up' : 'arrow-down'"></i>
                  </td>
                </tr>
                <tr v-if="exandedIndexFleche === index" :key="'details-' + index">
                  <td colspan="2" class="lignebis">
                    <p><strong>{{ $t('_identifiant_rampant_') }}: </strong>{{ item.plane_id }}</p>
                    <p><strong>{{ $t('_type_onduleurs_') }} : </strong>{{ item.inv_model }}</p>
                    <p><strong>{{ $t('_type_modules_') }}: </strong>{{ item.pv_model }}</p>
                    <p><strong>{{ $t('_nb_modules_chaine_') }} : </strong>{{ item.module_nb }}</p>
                    <p><strong>{{ $t('_nb_chaines_en_parallele_') }} : </strong>{{ item.string_nb }}</p>
                    <p><strong>INITIAL {{ $t('_nb_modules_chaine_') }} : </strong>{{ item.init_module_nb }}</p>
                    <p><strong>INITIAL {{ $t('_nb_chaines_en_parallele_') }} : </strong>{{ item.init_string_nb }}</p>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { LMap, LControl, LFeatureGroup, LPolygon } from 'vue2-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';

import 'leaflet-toolbar/dist/leaflet.toolbar.css'
import 'leaflet-toolbar';

import 'leaflet-distortableimage'
import 'leaflet-distortableimage/dist/leaflet.distortableimage.css'

import "leaflet-path-drag";
import api from "@/api/api";
import backend from '@/api/backend';
import Attribution from "./PopUpAttribution.vue"

//Presque comme la tileLayer cloassique de esri mais ajouter différemment pour ajouter un zoom artificiel
const CustomTileLayer = {
  name: 'CustomTileLayer',
  props: ['url', 'attribution', 'maxZoom', 'maxNativeZoom'],
  mounted() {
    const tileLayer = L.tileLayer(this.url, {
      attribution: this.attribution,
      maxZoom: this.maxZoom,
      maxNativeZoom: this.maxNativeZoom,
      noWrap: true,
      tms: false,
    });

    tileLayer.addTo(this.$parent.mapObject);


  },
  render() {
    return null;
  }
};

export default {
  components: { LMap, LFeatureGroup, LControl, LPolygon, Attribution, CustomTileLayer },

  async mounted() {

    this.isLoaded = true

    //Si le site existe dans la base d'helioicity, recuperer les infos la bas
    try {
      var res = (await api.get_layout_model_global_info(this.installation_id))
      // this.markerLatLng = [res.data.latitude, res.data.longitude]
      this.site = res.data.name

      res = (await api.get_all_full_layout(this.installation_id))
      this.mpps = res.data
      this.mpps.forEach((mpp) => {
        mpp["id"] = mpp.mpp
      })
    } catch //Sinon c'est que c'est un site créée dans l'appli, recuperer les info chez nous 
    {
      const res = (await backend.get_install_form(this.installation_id)).data
      const calepinage = res.layouts
      const historique = res.history
      this.mpps = []
      for (const idLigne in calepinage) {
        const json = {}
        json["init_module_nb"] = calepinage[idLigne].initNbModule
        json["init_string_nb"] = calepinage[idLigne].initNbChaine
        for (let idOnduleur in historique) {
          if (historique[idOnduleur].nom === calepinage[idLigne].nomOnduleur)
            json["inv_model"] = historique[idOnduleur].type
        }
        json["module_nb"] = calepinage[idLigne].nbModule
        json["mpp"] = calepinage[idLigne].nom
        json["plane_id"] = calepinage[idLigne].idRampant
        json["pv_model"] = calepinage[idLigne].typeModule
        json["string_nb"] = calepinage[idLigne].nbChaine
        json["id"] = calepinage[idLigne].cleMpp
        this.mpps.push(json)
      }
    }
    await this.fetchContours();
    await this.fetchRectanglesMpp();

    //Ajoute la possibilité de dessiner sur la carte
    this.$nextTick(async () => {
      const featureGroup = this.$refs.featureGroup.mapObject;

      // Initialisation de la barre d'outils de dessin
      this.drawControl = new L.Control.Draw({
        edit: {
          featureGroup: featureGroup,
          edit: true,
          remove: true,
        },
        draw: {
          circle: false,
          marker: false,
          polyline: false,
          circlemarker: false,
          rectangle: true,
        },
      });

      // Ajouter le contrôle de dessin à la carte
      this.$refs.refMap.mapObject.addControl(this.drawControl);
      this.addDuplicateButton();

      this.markerLayer = new L.layerGroup()
      this.markerLayer.addTo(this.$refs.refMap.mapObject)

      //Gère les evenements causés par le dessin

      this.$refs.refMap.mapObject.on('draw:deleted', this.onDeleted);

      //Permet de gerer l'affichage du perimetre
      this.$refs.refMap.mapObject.on('draw:drawstart', () => { this.isDrawing = true });
      this.$refs.refMap.mapObject.on('draw:drawstop', () => { this.isDrawing = false });

      this.$refs.refMap.mapObject.on('draw:created', this.onCreated);

      //Permet que la popup d'affectation ne s'ouvre pas quand on clique sur un bloc pour le supprimer
      this.$refs.refMap.mapObject.on('draw:deletestart', () => { this.isDeleting = true });
      this.$refs.refMap.mapObject.on('draw:deletestop', () => { this.isDeleting = false });

      this.$refs.refMap.mapObject.on('draw:editstart', this.onEditstart)
      this.$refs.refMap.mapObject.on('draw:editstop', this.onEditstop)

      //Ajoute la photo si il y en a une
      try {

        let corners = (await backend.get_mask_install(this.installation_id)).data
        let fileURL = URL.createObjectURL((await backend.get_mask_file_install(this.installation_id)).data)

        const map = this.$refs.refMap.mapObject

        const options = {
          corners: corners,
          suppressToolbar: true,
          editable: false,
          actions: [],
          mode: ''
        }

        this.overlay = L.distortableImageOverlay(fileURL, options).addTo(map)
        this.imageExiste = true
        URL.revokeObjectURL(fileURL);

      }
      catch (error) {
        console.error("Pas d'image à recuperer")
      }

    })
  },


  data() {
    return {
      editing: false,
      drawControl: null,
      installation_id: this.$route.params.id,
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      zoom: 17,
      // markerLatLng: [0, 0],
      center: [48.866667, 2.333333],

      bounds: null,

      tileProviders:
      {

        url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png",
        visible: true,
        name: "satelliteESRI",
        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
      },

      mpps: [],
      exandedIndexFleche: null,
      exandedIndexOeil: null,
      modalState: false,
      modalCoords: null,
      modalMpp: null,
      blockIndex: null,
      timer: null,
      nbrPoly: 0,

      polygonCoords: [],
      rectangles: [],
      mpp_assigned: [],
      binActive: false,
      nextId: 1,
      isDeleting: false,
      isLoaded: false,
      isDuplicationMode: false,
      controlPanel: null,
      markerLayer: null,
      show: true,
      duplicateButton: null,
      isDrawing: false,
    };
  },

  computed: {
    //trie les mpp selon leur id (de la forme idInv-numEntréeDC)
    sortedMpps() {
      return [...this.mpps].sort((a, b) => {
        const [a1, a2] = a.id.split('-').map(Number);  // Extraire les parties numériques
        const [b1, b2] = b.id.split('-').map(Number);  // Extraire les parties numériques

        // Comparer d'abord la première partie, puis la deuxième si égalité
        if (a1 === b1) {
          return a2 - b2;
        }
        return a1 - b1;
      });
    },
  },

  watch: {
    //Surveille quels blocs doivent aparaitre en jaune
    exandedIndexOeil() {
      this.$refs.featureGroup.mapObject.eachLayer(polygone => {
        polygone.setStyle(this.getStylePolygon(polygone))
      })
    },

    //met a jour la carte apres le fermement de la popup affectation
    modalState() {
      this.$refs.featureGroup.mapObject.eachLayer(polygone => {
        polygone.setStyle(this.getStylePolygon(polygone))
        polygone.bindTooltip(this.getTooltipText(polygone), {
          permanent: false,
          direction: 'top',
          offset: [0, -10]
        });
      })

      this.updateData();
    },

    isDeleting() {
      this.$forceUpdate();
    },

    isLoaded() {
      this.$forceUpdate();
    },

  },


  methods: {

    //recupere les contours de l'installation dans le back
    async fetchContours() {
      try {
        const response = await backend.get_edges_install(this.installation_id);
        this.polygonCoords = response.data;

        await this.$nextTick();

      } catch (err) {
        this.$emit("detour");
      }
    },

    //recupere les coordoné des différents blocs et leurs mpp associés dans le back et appelle la fonction qui les affiche
    async fetchRectanglesMpp() {
      try {
        const [response1, response2] = await Promise.all([backend.get_blocs_install(this.installation_id), backend.get_m_pts_install(this.installation_id)]);
        this.rectangles = response1.data;
        this.mpp_assigned = response2.data;

        await this.$nextTick();

      } catch (err) {
        this.rectangles = [];
        this.mpp_assigned = [];
      }
      this.initPolygons();
    },

    //Crée le contour sur la carte et centre la carte dessus, et appelle la fonction qui crée chaque polygone
    initPolygons() {
      const poly = L.polygon(this.polygonCoords);
      this.$refs.refMap.mapObject.fitBounds(poly.getBounds());
      this.rectangles.forEach((rectangle, index) => {
        this.addPolygonToLayer(rectangle, this.mpp_assigned[index], index);
      });
    },

    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    getMenu() {
      return this.$store.getters.installations.find(x => x.id == this.$route.params.id)?.target_menu
    },
    map_ready() {
      this.$r
    },

    //Crée un bloc, en lui attribuant ses mpp, et l'ajoute à la carte
    addPolygonToLayer(rectangle, mppIds, index) {
      //crée un polygone déplaçable qui a les bonne coordonnées
      const polygon = L.polygon(rectangle, { draggable: true })
      //lui donnée ses mpp comme propriété
      polygon.options.mpp = mppIds;
      polygon.id = index;

      //configuerer son comportemeny quand on clique dessus
      polygon.on('click', () => {
        if (!this.isDeleting && !this.editing && !this.isDuplicationMode)
          this.openModal(polygon);
      });

      //ajouter le tooltip
      polygon.bindTooltip(this.getTooltipText(polygon), {
        permanent: false,    // Le tooltip apparaîtra au survol
        direction: 'top',    // Position du tooltip par rapport au polygone
        offset: [0, -10]     // Décalage du tooltip
      });

      //defini le style du polygone
      polygon.setStyle(this.getStylePolygon(polygon));
      //n'est pas deplaçable initialement
      polygon.dragging.disable();
      //Ajouter au featuregroupe (et donc a la carte)
      this.$refs.featureGroup.mapObject.addLayer(polygon);
      this.nextId += 1;
      this.$forceUpdate()
    },

    onCreated(event) {
      this.isDrawing = false //pour ne plus afficher le périmetre
      const layer = event.layer;
      const latlng = layer._latlngs

      this.addPolygonToLayer(latlng, [], this.nextId)
      this.updateData();
    },

    onDeleted(event) {
      const deletedLayers = event.layers;

      if (deletedLayers && deletedLayers.getLayers().length > 0) {
        deletedLayers.eachLayer((layer) => {
          this.$refs.featureGroup.mapObject.removeLayer(layer);
        });

        this.updateData();

      } else {
        console.error("Aucune couche supprimée trouvée.");
      }
    },

    //enregistre les données dans le back
    updateData() {
      this.rectangles = [];
      this.mpp_assigned = [];
      this.$refs.featureGroup.mapObject.eachLayer(polygone => {
        var latLngs = polygone.getLatLngs()[0].map(coord => [coord.lat, coord.lng]);
        latLngs.push(latLngs[0]);
        this.rectangles.push(latLngs);
        this.mpp_assigned.push(polygone.options.mpp);
      })

      // Envoi des rectangles et des points de mesures 
      backend.put_blocs_install(this.installation_id, this.rectangles);
      backend.put_m_pts_install(this.installation_id, this.mpp_assigned);
    },

    openModal(polygon) {
      this.modalState = true;
      this.modalCoords = polygon.getLatLngs();
      this.modalMpp = polygon.options.mpp;
      this.blockIndex = polygon.id;
    },

    onDetourage() {
      this.$emit("detour");
    },

    closeModal() {
      this.modalState = false;
    },

    //Enregistre les nouveau mpp assignés a un bloc
    saveMpp(ptDeMesure, blockIndex) {
      this.modalState = false;
      this.$refs.featureGroup.mapObject.eachLayer(polygone => {
        if (polygone.id === blockIndex) {
          polygone.options.mpp = ptDeMesure
        }
      })
    },

    //Crée les nouveau blocs correctement parametrés apres la séparation d'un bloc
    saveNewBlocs(formes, blockIndex) {
      this.modalState = false;
      this.$refs.featureGroup.mapObject.eachLayer(polygone => {
        if (polygone.id === blockIndex) {
          this.$refs.featureGroup.mapObject.removeLayer(polygone);
        }
      })

      for (let i = 0; i < formes.coordinates.length; i++) {
        for (let j = 0; j < formes.coordinates[i].length; j++) {
          const rectangle = formes.coordinates[i][j];
          const ptDeMesure = [];
          ptDeMesure.push(formes.ptDeMesure[i]);
          const index = this.nextId;
          this.nextId += 1;
          this.addPolygonToLayer(rectangle, ptDeMesure, index);
        }
      }
    },

    toggleDetails(index) {
      this.exandedIndexFleche = this.exandedIndexFleche === index ? null : index;
    },

    toggleOeil(index) {
      this.exandedIndexOeil = this.exandedIndexOeil === index ? null : index;
    },

    //permet de gerer la couleur des mpp dans le tableau de droite
    isAllocated(id) {
      let found = false;
      this.$refs.featureGroup.mapObject.eachLayer(polygone => {
        if (polygone.options.mpp.includes(id)) {
          found = true;
        }
      })
      return found;
    },

    //dit si un bloc est mpp selectionné ou non
    mppSelectBloc(polygon) {
      if (this.exandedIndexOeil != null)
        return polygon.options.mpp.includes(this.mpps[this.exandedIndexOeil].id);
    },

    getStylePolygon(layer) {
      let color = (layer.options.mpp.length === 0) ? 'red' : 'blue';
      let fcolor = (layer.options.mpp.length === 0) ? 'red' : (this.mppSelectBloc(layer)) ? 'yellow' : 'blue';
      let fopa = (this.mppSelectBloc(layer)) ? 0.6 : 0.3;
      return {
        color: color,
        fillColor: fcolor,
        fillOpacity: fopa,
      }
    },

    getTooltipText(layer) {
      var tooltipText = null;
      if (layer.options.mpp.length < 1) {
        tooltipText = this.$t('_pas_de_point_associe_')
      }
      else {
        tooltipText = this.$t('_point_associe_') + ' : ' + this.getNamesFromIds(layer.options.mpp)
      }
      return tooltipText;
    },

    getNamesFromIds(ids) {
      let names = []
      this.mpps.forEach((mpp) => {
        if (ids.includes(mpp.id))
          names.push(mpp.mpp)
      })
      return names
    },

    //affiche tous les mpps liées aux blocs en même temps
    toggleText() {
      if (this.show) {
        this.$refs.featureGroup.mapObject.eachLayer(polygone => {
          const centrePoly = polygone.getBounds().getCenter()
          const text = '<p style="font-weight: bold; width: fit-content; text-align: center; color: white; text-shadow:0px 0px 5px #000 "> Bloc ' + polygone.id + ', ' + this.getTooltipText(polygone) + '</p>'
          var marker = new L.marker(centrePoly, {
            icon: L.divIcon({
              className: 'label',
              html: text,
              iconSize: [text.length * 1.30, 20]
            })
          })
          this.markerLayer.addLayer(marker)
        })
      }
      else {
        this.markerLayer.eachLayer(marker => {
          this.markerLayer.removeLayer(marker)
        })
      }
      this.show = !this.show
    },

    //ajoute le bouton pour dupliquer une forme à la carte
    addDuplicateButton() {
      const DuplicateControl = L.Control.extend({
        onAdd: () => {
          const btn = L.DomUtil.create('button', 'leaflet-bar');
          btn.innerHTML = '<i class="mdi mdi-plus-box-multiple-outline"></i>';
          btn.title = this.$t('_dupliquer_un_objet_');
          btn.style.width = '34px';
          btn.style.height = '34px';
          btn.style.backgroundColor = this.isDuplicationMode ? 'grey' : 'white';
          btn.style.fontSize = '20px';

          L.DomEvent.on(btn, 'click', (e) => {
            L.DomEvent.stopPropagation(e);
            L.DomEvent.preventDefault(e);
            this.toggleDuplicationMode();
          });
          this.duplicateButton = btn
          return btn;
        },
      });

      this.$refs.refMap.mapObject.addControl(new DuplicateControl({ position: 'topleft' }));
    },

    toggleDuplicationMode() {
      this.isDuplicationMode = !this.isDuplicationMode;
      this.duplicateButton.style.backgroundColor = this.isDuplicationMode ? '#DDDDDD' : 'white';
      if (this.isDuplicationMode) {
        this.$refs.featureGroup.mapObject.eachLayer((layer) => {
          layer.on('click', this.onLayerClickForDuplication);
        })
      }
    },

    //duplique un objet de la carte
    onLayerClickForDuplication(e) {
      if (!this.isDuplicationMode) return;

      const layer = e.target;
      this.$refs.refMap.mapObject.getContainer().style.cursor = '';

      // Dupliquer légèrement déplacé
      let movedLatLngs
      if (layer instanceof L.Polygon) {
        const latlngs = JSON.parse(JSON.stringify(layer.getLatLngs()));
        // Déplace un peu chaque point
        const offset = 0.00005;
        movedLatLngs = latlngs.map((pointGroup) =>
          pointGroup.map((point) => ({
            lat: point.lat + offset,
            lng: point.lng + offset,
          }))
        );
      }

      this.addPolygonToLayer(movedLatLngs, [], this.nextId)
      this.updateData();
    },

    //gere le passage en mode edition
    onEditstart() {
      //permet d'afficher le perimetre
      this.editing = true

      // Permet le déplacement de chaques polygones
      var editableLayers = this.drawControl._toolbars.edit.options.featureGroup._layers;
      Object.values(editableLayers).forEach(layer => {
        if (layer instanceof L.Polygon) {
          layer.dragging.enable(); // Permet le déplacement du polygone
          //permet que les points d'edition suivent le polygone quand on le deplace
          layer.on('dragend', () => {
            if (layer.editing && layer.editing.enabled()) {
              layer.editing.disable();
              layer.editing.enable();
            }
          });
        }
      })
    },

    //quand l'edition est fini (au clique sur save)
    onEditstop() {
      //enleve le contour du site
      this.editing = false

      // Désactive le déplacement de chaque forme
      var editableLayers = this.drawControl._toolbars.edit.options.featureGroup._layers;
      Object.values(editableLayers).forEach(layer => {
        if (layer.dragging) {
          layer.dragging.disable(); 
        }
      });
      this.updateData();
    }
  }
};
</script>

<style scoped>
.small-map {
  height: 100%;
  width: 100%;
  aspect-ratio: 1 / 1;
  z-index: 0;
}

.title2 {
  font-size: 40px;
}

.texte {
  margin-top: 10%;
  font-size: 20px;
}

/* button{
      transition: transform 0.2s;
    } */

table {
  width: 90%;
  float: right;
  border-collapse: collapse;
  table-layout: fixed;
}

th,
td {
  /* border: 1px solid #ccc; */
  padding: 10px;
  text-align: left;
  /* cursor: pointer; */
}

.fleche {
  background-color: transparent;
  /* background-color: aquamarine; */
  border-style: solid;
  border-width: 1px;
  border-color: #242424;
  cursor: pointer;
  font-size: 20px;
  width: 100%;
  height: 100%;
}

.eye-select {
  float: right;
  /* background-color: aqua; */
  width: 3vw;
  color: #2546da;
  font-weight: bold;
  font-size: large;
}

.eye {
  float: right;
  /* background-color: aqua; */
  width: 3vw;
  color: #000000;
  font-size: large;
}

.ligneAlloue {
  /* background-color: dynamicBackgroundColor; */
  /* background-color: aquamarine  ; */
  border-style: solid;
  border-width: 1px;
  border-color: #242424;
  background-color: #EEEEEE;
  width: 90%;
}

.lignePasAlloue {
  border-style: solid;
  border-width: 1px;
  border-color: #242424;
  background-color: #d38282;
  width: 90%;
}

.lignebis {
  background-color: #FFFFFF;
  border-style: solid;
  border-width: 1px;
}

.arrow-down:before {
  content: "↓";
}

.arrow-up:before {
  content: "↑";
}

.details-row {
  background-color: #eef;
}

/* 
    td:first-child {
      background-color: #f9f9f9;
      width: 90%;
      border:#242424;
    } */

td:nth-child(2) {
  width: 60px;
  /* background-color: #e28b8b; */
  text-align: center;
}

tbody {
  display: block;
  width: 20vw;
  max-height: 70vh;
  /* Permet de scroller */
  overflow-y: auto;
}

.seeButton {
  background: #fff;
  padding: 0 0.5em;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #000000;
}
</style>
